import { useTranslate } from 'hooks/useTranslations';
import { useSiteConfig } from 'hooks/useSiteConfig';

const formatTitle = ({ group, translate, locale }) => {
  switch (group) {
    case 'unavailable':
      return `${translate('estimatedArrival')}: ${translate(
        'dateUnavailable'
      )}`;
    case 'giftCards':
      return translate('digitalGiftCardSectionLabel');
    default:
      const endDate = group
        ? new Date(`${group.split('T')[0]}T00:00`)
        : new Date();
      const estimatedArrivalDate = new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
      }).format(endDate);
      return `${translate('estimatedArrival')}: ${estimatedArrivalDate}`;
  }
};

export const GroupedCartItemsTitle = ({ group }) => {
  const translate = useTranslate();
  const { locale } = useSiteConfig();

  return (
    <h3 className="text-puma-green font-bold bg-puma-black-700 p-2 pl-4 text-sm uppercase mt-4 mb-0">
      {formatTitle({ group, translate, locale })}
    </h3>
  );
};
